import { isNumber } from 'lodash-es'

import CustomShaderMaterial from '../../libs/three-custom-shader-material'

import { CHUNK_WIDTH, DAY_LENGTH, DAY_LENGTH_SECONDS } from '../../core/chunks'

import * as THREE from '../three'

import { System } from './System'
import { createSky } from '../../core/createSky'

const col1 = new THREE.Color()

// // // fix fog distance calc
// // // see: https://github.com/mrdoob/three.js/issues/14601
// // // future: https://www.youtube.com/watch?v=k1zGz55EqfU
// // THREE.ShaderChunk.fog_vertex = `
// // #ifdef USE_FOG

// //   // original
// //   // vFogDepth = - mvPosition.z;

// //   // radial distance
// //   // vFogDepth = length( mvPosition );

// //   // cylindrical (ignore altitude)
// //   vFogDepth = length( mvPosition.xz );

// //   // height-based (eg ground fog)
// //   // vFogDepth = abs( mvPosition.y );

// // #endif
// // `

// // // cylindrical fog using world position so its stable when tilting the camera up/down
// // THREE.ShaderChunk.fog_vertex = `
// // #ifdef USE_FOG
// //   vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;
// //   // #ifdef USE_INSTANCING
// //   //   worldPos = (instanceMatrix * vec4(worldPos, 1.0)).xyz;
// //   // #endif
// //   vFogDepth = length( (worldPos - cameraPosition) * vec3(1.0, 0.0, 1.0) );
// // #endif
// // `

// // cylindrical-ish fog using Chebyshev distance on XZ in world space
// THREE.ShaderChunk.fog_vertex = `
// #ifdef USE_FOG
//   vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;

//   // If you actually use instancing, re-enable this block and compute from object space:
//   // #ifdef USE_INSTANCING
//   //   worldPos = (instanceMatrix * vec4(worldPos, 1.0)).xyz;
//   // #endif

//   vec3 d = worldPos - cameraPosition;

//   // Chebyshev distance on the ground plane (XZ). Ignores Y to make it tilt-stable.
//   float chebXZ = max(abs(d.x), abs(d.z));

//   // three.js just uses vFogDepth as "distance"; any scalar works.
//   vFogDepth = chebXZ;
// #endif
// `

export class SkySystem extends System {
  constructor(client) {
    super(client)
    this.textureLoader = new THREE.TextureLoader()
  }

  init() {
    this.sky = createSky()
    this.sky.time = 0.5 // todo
    this.sky.viewDistance = 8 // todo
    this.sky.load('/skyLUT.png')
  }

  start() {
    this.client.graphics.scene.add(this.sky.mesh)
    this.client.graphics.scene.fog = this.sky.fog
    this.client.prefs.on('change', this.onPrefsChange)
  }

  setup({ time, timeFrozen, timeDayMinutes, viewDistance }) {
    this.sky.time = time
    this.sky.timeFrozen = timeFrozen
    this.sky.timeDayMinutes = timeDayMinutes
    this.sky.viewDistance = viewDistance
  }

  // async init() {
  //   // matches Studio.js
  //   this.skyLUT = await this.textureLoader.loadAsync('/skyLUT.png')
  //   this.skyLUT.flipY = false
  //   this.skyLUT.magFilter = THREE.LinearFilter
  //   this.skyLUT.minFilter = THREE.LinearFilter
  //   this.skyLUT.generateMipmaps = false
  //   this.skyLUT.wrapS = THREE.RepeatWrapping // repeat horizontally
  //   this.skyLUT.wrapT = THREE.ClampToEdgeWrapping // not vertically
  //   this.skyLUT.anisotropy = 1
  //   this.skyLUT.colorSpace = THREE.SRGBColorSpace
  //   this.skyLUT.needsUpdate = true

  //   this.sampleSkyLut = createSkyLutSampler(this.skyLUT.image)

  //   this.uniforms = {
  //     uTime: { value: 0.5 }, // 0 midnight, 0.5 noon, 1 midnight, repeating
  //     uSkyLUT: { value: this.skyLUT },
  //     uSkyLUTSize: { value: new THREE.Vector2(this.skyLUT.image.width, this.skyLUT.image.height) },
  //   }
  //   this.skyMaterial = new THREE.MeshBasicMaterial({
  //     depthWrite: false,
  //     depthTest: false,
  //     side: THREE.BackSide,
  //     toneMapped: false,
  //     fog: false,
  //   })
  //   this.skyMaterial = new CustomShaderMaterial({
  //     baseMaterial: this.skyMaterial,
  //     uniforms: {
  //       ...this.uniforms,
  //     },
  //     vertexShader: `
  //       varying vec3 vWorldPos;

  //       void main() {
  //         // transform to world
  //         vec4 wp = modelMatrix * vec4(position, 1.0);
  //         vWorldPos = wp.xyz;
  //         csm_PositionRaw = projectionMatrix * viewMatrix * wp;
  //       }
  //     `,
  //     fragmentShader: `
  //       precision highp float;

  //       uniform float uTime;
  //       uniform sampler2D uSkyLUT;
  //       uniform vec2 uSkyLUTSize;

  //       varying vec3 vWorldPos;

  //       vec3 sampleRow(float u, float rowIndex) {
  //         // sample at column u, row center
  //         float v = (rowIndex + 0.5) / uSkyLUTSize.y;
  //         return texture2D(uSkyLUT, vec2(u, v)).rgb;
  //       }

  //       void main() {
  //         // normalized view direction in world space
  //         vec3 dir = normalize(vWorldPos - cameraPosition);

  //         // time → column at texel centers (assumes uTime in [0,1) across a day)
  //         float u = (fract(uTime) * uSkyLUTSize.x + 0.5) / uSkyLUTSize.x;

  //         // fetch triplet (TOP / horizon / BOTTOM)
  //         vec3 cTop     = sampleRow(u, 0.0);  // row 0: TOP of the sky
  //         vec3 cHorizon = sampleRow(u, 1.0);  // row 1: horizon
  //         vec3 cBottom  = sampleRow(u, 2.0);  // row 2: BOTTOM of the sky

  //         // map dir.y (-1..+1) → height 0..1
  //         float h = clamp(dir.y * 0.5 + 0.5, 0.0, 1.0);

  //         // two-band gradient with a soft horizon
  //         vec3 ratios = vec3(0.5, 0.7, 1.0); // x=bottomStart, y=horizonCenter, z=topStart  (all in [0,1])
  //         float band = smoothstep(ratios.y - 0.10, ratios.y + 0.10, h);
  //         vec3  low  = mix(cBottom,  cHorizon, smoothstep(ratios.x, ratios.y, h));
  //         vec3  high = mix(cHorizon, cTop,     smoothstep(ratios.y, ratios.z, h));
  //         vec3  sky  = mix(low, high, band);

  //         // output (LUT authored in sRGB, but three.js will convert when colorSpace is sRGB on the texture;
  //         // we keep shader in linear; that’s fine since uSkyLUT was sampled through the fixed-function sampler)

  //         csm_DiffuseColor = vec4(sky, 1.0);
  //       }
  //     `,
  //   })
  //   this.skyGeometry = new THREE.BoxGeometry(50, 50, 50)
  //   this.skyMesh = new THREE.Mesh(this.skyGeometry, this.skyMaterial)
  // }

  // async start() {
  //   this.fogColor = new THREE.Color(1, 1, 1)
  //   this.fog = new THREE.Fog(this.fogColor, 0, 10000)
  //   this.client.graphics.scene.fog = this.fog
  //   this.updateFog()

  //   this.client.graphics.scene.add(this.skyMesh)
  //   this.client.prefs.on('change', this.onPrefsChange)
  // }

  preTick(delta) {
    this.sky.update(delta)

    // // console.warn('todo: sky system timeSpeed')
    // this.timeSpeed = 7200 // todo
    // // advance time (todo: fixed time, speed etc)
    // this.sky.time += (this.timeSpeed * delta) / DAY_LENGTH_SECONDS
    // // this.sky.time += delta / DAY_LENGTH

    // // advance time
    // this.uniforms.uTime.value += delta / DAY_LENGTH
    // // update fog color to match horizon (3rd row of pixels)
    // const target = this.sampleSkyLut(2, this.uniforms.uTime.value)
    // this.fog.color.copy(target)
  }

  lateUpdate(delta) {
    // sky follow camera
    this.client.graphics.camera.getWorldPosition(this.sky.mesh.position)
  }

  // async updateFog() {
  //   const viewDistance = this.client.prefs.viewDistance
  //   const near = CHUNK_WIDTH * (viewDistance - 2)
  //   const far = CHUNK_WIDTH * (viewDistance - 1)
  //   this.fog.near = near
  //   this.fog.far = far
  // }

  onPrefsChange = changes => {
    if (changes.viewDistance) {
      this.sky.deviceViewDistance = this.client.prefs.viewDistance
      // this.updateFog()
    }
  }
}

// function createSkyLutSampler(image) {
//   const { width, height } = image

//   // draw to an offscreen canvas once to read pixels
//   const canvas = document.createElement('canvas')
//   canvas.width = width
//   canvas.height = height
//   const ctx = canvas.getContext('2d', { willReadFrequently: true })
//   ctx.drawImage(image, 0, 0)
//   const data = ctx.getImageData(0, 0, width, height).data

//   const srgbToLinear = u => {
//     const c = u / 255
//     return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
//   }

//   const linear = Array.from({ length: height }, () => Array(width))

//   for (let row = 0; row < height; row++) {
//     for (let col = 0; col < width; col++) {
//       const i = (row * width + col) * 4
//       const r = srgbToLinear(data[i + 0])
//       const g = srgbToLinear(data[i + 1])
//       const b = srgbToLinear(data[i + 2])
//       linear[row][col] = new THREE.Color(r, g, b) // linear
//     }
//   }

//   const col = new THREE.Color()

//   // smooth horizontal sample of a LUT row at fractional column
//   return (row, t01) => {
//     const x = (t01 - Math.floor(t01)) * width // [0,width)
//     const i0 = Math.floor(x) % width
//     const i1 = (i0 + 1) % width
//     const f = x - i0

//     const c0 = linear[row][i0]
//     const c1 = linear[row][i1]

//     // col = mix(c0, c1, f) in linear space
//     col.copy(c0).lerp(c1, f)
//     return col
//   }
// }
